export const USER_ROLES = {
  SUPER_ADMIN: "super_admin",
  MANAGER: "manager",
  EMPLOYEE: "employee",
  MEMBER: "member",
};

export const ROLE_LABELS = {
  [USER_ROLES.SUPER_ADMIN]: "Super Admin",
  [USER_ROLES.MANAGER]: "Manager",
  [USER_ROLES.EMPLOYEE]: "Employee",
  [USER_ROLES.MEMBER]: "Member",
};

export const PAGE_ACCESS = {
  dashboard: [
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.MANAGER,
    USER_ROLES.EMPLOYEE,
    USER_ROLES.MEMBER,
  ],
  tickets: [
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.MANAGER,
    USER_ROLES.EMPLOYEE,
    USER_ROLES.MEMBER,
  ],
  employees: [
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.MANAGER,
  ],
  departments: [
    USER_ROLES.SUPER_ADMIN,
  ],
  projects: [
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.MANAGER,
  ],
  reports: [
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.MANAGER,
  ],
  resource_management: [
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.MANAGER,
  ],
};

export const normalizeRole = (roleName) => {
  if (!roleName) {
    return USER_ROLES.MEMBER;
  }

  const normalized = String(roleName).trim().toLowerCase();

  if (Object.values(USER_ROLES).includes(normalized)) {
    return normalized;
  }

  return USER_ROLES.MEMBER;
};

export const canAccessPage = (roleName, pageKey) => {
  const normalizedRole = normalizeRole(roleName);
  const allowedRoles = PAGE_ACCESS[pageKey] || [];
  return allowedRoles.includes(normalizedRole);
};
